import React from 'react';

function FooterBar() {
  return (
    <div id="footer">
      <div id="Footer">
        <p>Water Vapor &copy; 2022. All Rights Reserved.</p>
      </div>
    </div>
  );
}

export default FooterBar;
